<template>
  <div class="home_wrap">
    <!-- <div class="red_top_bg">
			<div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/'+lang+'.png')">
			</div>
		    <div class="search_box" @click="$router.push('/search')">
		        <i class="fdj"></i>
		        <input type="text" readonly :placeholder="$t('index.search')" class="search_inp">
		        <div class="clear_inp"></div>
		    </div>
			<div class="msg" @click="$router.push('/notice')">
				<img src="../images/index/msg.png">
			</div>
		</div> -->
    <div class="red_top_bg m-flex m-f-between m-pd1">
      <div class="logos" @click="$router.push('index')">
        <img :src="logo" alt="" />
      </div>
      <div class="not_logo" style="margin-left: auto;" @click="$router.push('notice')">
        <img src="@/assets/images/notice.png" alt="" />
        <span class="num" v-if="notice_num > 0">{{notice_num}}</span>
      </div>
      <div class="menu" style="margin-left: 15px;" @click="$router.push('menu')">
        <!-- {{ $t("menu") }} -->
        <img src="@/assets/images/menus.png" alt="" />
      </div>
    </div>
    <div style="height: 44px;"></div>
    <div v-if="data.banner.length > 0">
      <van-swipe :autoplay="2500" class="swiper-container text-center"  @change="onChange">
        <van-swipe-item v-for="(image, index) in data.banner" :key="index">
          <router-link :to="image.url">
            <img style="object-fit: fill;" :src="image.img_url" />
          </router-link>
        </van-swipe-item>
        <div ref="dian" slot="indicator" class="custom-indicator">
          <div
            v-for="(img, x) in data.banner"
            :key="x"
            :class="x === 0 ? 'selected' : ''"
          />
        </div>
      </van-swipe>
    </div>
    <div class="bg-video" v-if="videoSrc != ''">
      <video
        ref="videoPlayer"
        :src="videoSrc"
        controls
        loop
        autoplay
        muted
        @loadeddata="onVideoLoaded"
        @ended="onVideoEnded"
      ></video>
    </div>
    <template v-if="notices != ''">
      <van-notice-bar :text="notices" scrollable left-icon="volume" />
    </template>
    <div v-if="!loading" class="work_box query">
      <div v-for="i in 10" class="item">
        <div class="item_img" />
        <p class="item_title" />
      </div>
    </div>
    <div class="item_wrap">
      <div class="h-title">{{ $t('home_title') }}</div>
      <div class="tabs">
				<van-tabs v-model="active" background="#fff" @click="sort">
				  <van-tab v-for="index in tabs" :title="index.name"></van-tab>
				</van-tabs>
			</div>
      <div class="items_3 item_margin" v-if="wealth_data.list && wealth_data.list.length > 0">
        <div v-for="i in wealth_data.list.slice(0,3)" :key="i.id" class="item">
          <div class="item_img" @click="$router.push('/item/' + i.id)">
            <img :src="i.img" alt="" />
          </div>
          <div class="item_div1" @click="$router.push('/item/' + i.id)">
            <p>
              {{ i[lang] }}
            </p>
          </div>
          <div class="item_div2" @click="$router.push('/item/' + i.id)">
            <div class="item_rate divs">
              <img class="logos" src="@/assets/images/zzcb.png" alt="">
              <div style="flex-direction: column;">
                <p style="white-space: nowrap;"><span>{{ i.total}}</span></p>
                <p>{{ $t("制作成本") }}</p>
              </div>
            </div>
            <div class="item_day divs">
              <img class="logos" src="@/assets/images/mll.png" alt="">
              <div style="flex-direction: column;">
                <p><span>{{ i.rate }}%</span></p>
                <p>{{ $t("rgll") }}</p>
              </div>
            </div>
            <div class="item_min divs">
              <img class="logos" src="@/assets/images/qd2.png" alt="">
              <div style="flex-direction: column;">
                <p><span><span :style="i.project_type ===  1?'font-size:16px;':'font-size:16px;'">{{ i.project_type ===  1?'$':$t("utils.moneyMark") }}</span>{{ i.min }}</span></p>
                <p>{{ $t("utils.startingAmount") }}</p>
              </div>
            </div>
          </div>
          <!-- <div class="item_div3" v-if="i.project_type ===  1">
            <span>{{ $t("utils.Handling") }}:<span style="font-size: 12px;color:#333;">{{ i.fee_ratio }}%</span></span>
          </div> -->
          <!-- <div class="item_div3" v-if="i.project_type ===  1">
            <span>{{ $t("utils.default") }}:<span style="font-size: 12px;color:#333;">{{ i.breach_penalty_rate }}%</span></span>
          </div> -->
          <div class="item_div3" style="margin-top: 20px;">
            <span>{{ $t("认购方式") }} <b>:</b> <span style="color:#333;">{{ i.day_text }}</span></span>
          </div>
          <!-- <div class="item_div3">
						<span>{{ $t("fxbl") }}:<span style="color:#333;">{{ i.breach_penalty_rate }}</span></span>
					</div> -->
          <div class="item_div3">
            <span>{{ $t("票房预估") }} <b>:</b> <span style="color:#333;">{{ i.project_type ===  1?'$':$t("utils.moneyMark") }}</span><span style="font-size: 13px;color:#333;">{{ i.estimated_revenue }}</span></span>
            <div class="item_btn">
              <button v-if="i.percent < 100" type="button" @click="$router.push('/item/' + i.id)">
                {{ $t("utils.invest") }}
              </button>
              <button v-if="i.percent >= 100" class="item_btn_over" type="button">
                {{ $t("utils.investOver") }}
              </button>
            </div>
          </div>
          <div class="item_div4" v-if="i.id != 185">
            <div class="flexs">
              <span>{{ $t('认购进度') }}</span>
              <span>{{ i.percent }}%</span>
            </div>
            <van-progress :percentage="i.percent" />
          </div>
        </div>
        <div style="width:100%;height: 40px;display: flex;align-items: center;justify-content: center;background: #fff;border-bottom: 1px solid #eee;">
          <a style="font-size: 14px;color: #333;display: flex;align-items: center;" @click="$router.push('/item')">{{ $t('ckgd') }}
            <img src="@/assets/images/right_icon.png" alt="" style="display: block;width: 20px;height: 20px;">
          </a>
        </div>
      </div>
      
      <div class="items_3 items_4 item_margin">
        <div class="h-title">
          <span>{{ $t('华纳新闻资讯') }}</span>
        
        </div>
        <div class="tabs" style="margin-bottom:2px;">
          <van-tabs v-model="xwActive" background="#F6F6F6" @click="xwSort">
            <van-tab v-for="index in xwtabs" :title="index.title"></van-tab>
          </van-tabs>
        </div>
        <div v-for="i in xwList" :key="i.id" class="items">
          <div class="item_img" @click="$router.push('/journalismDetail/' + i.id)">
            <img :src="i.img_url" alt="" />
          </div>
          <div class="t1">
              {{i.time}}
          </div>
          <div class="newsroom__title">
              {{i.title}}
          </div>
        </div>
        <div style="width:100%;height: 40px;display: flex;align-items: center;justify-content: center;background: #fff;border-bottom: 1px solid #eee;">
          <a style="font-size: 14px;color: #333;display: flex;align-items: center;" @click="$router.push('/journalism')">{{ $t('ckgd') }}
            <img src="@/assets/images/right_icon.png" alt="" style="display: block;width: 20px;height: 20px;">
          </a>
        </div>
      </div>
     
      <div style="height:30px"></div>
      <van-dialog
        v-model="show_ts"
        show-cancel-button
        @confirm="confirm"
        @cancel="cancelFun"
        :confirmButtonText="$t('utils.confirm')"
        :cancelButtonText="$t('utils.cancel')"
      >
        <div class="items_3">
          <div class="item">
            <div class="item_div1">
              <p>
                {{ wealth_sku[lang] }}
              </p>
            </div>

            <div class="item_div2">
              <div class="item_rate">
                <p>{{ wealth_sku.rate }}%</p>
                <p>{{ $t("utils.dailyIncome") }}</p>
              </div>
              <div class="item_day">
                <p>{{ wealth_sku.day }}{{ wealth_sku.project_type ===  1? $t("utils.min"):$t("utils.hour")  }}</p>
                <p>{{ $t("utils.cycle") }}</p>
              </div>
              <div class="item_min">
                <p>{{ $t("utils.moneyMark") }}{{ wealth_sku.fixed_investment_amount_text }}</p>
                <p>{{ $t("utils.startingAmount") }}</p>
              </div>
            </div>
          </div>
        </div>
        <van-field
          v-model="wealth_number"
          type="number"
          :placeholder="$t('item.inputAmount')"
        />
      </van-dialog>
    </div>
  
    <van-dialog
      v-model="show_tz"
      show-cancel-button
      @confirm="confirm()"
      @cancel="cancelFun"
      :confirmButtonText="$t('utils.confirm')"
      :cancelButtonText="$t('utils.cancel')"
    >
      <div class="items_3">
        <div class="item">
          <div class="item_img">
            <img :src="sku.img" alt="" />
          </div>
          <div class="item_div1">
            <p>
              {{ sku[lang] }}
            </p>
          </div>
          <div class="item_text">
            {{ sku["desc_" + lang] }}
          </div>
          <div class="item_div2">
            <div class="item_rate">
              <p>{{ sku.rate }}%</p>
              <p>{{ $t("utils.dailyIncome") }}</p>
            </div>
            <div class="item_day">
              <p>{{ sku.day }}{{ sku.project_type ===  1? $t("utils.min"):$t("utils.hour")  }}</p>
              <p>{{ $t("utils.cycle") }}</p>
            </div>
            <div class="item_min">
              <p>{{ $t("utils.moneyMark") }}{{ sku.fixed_investment_amount_text }}</p>
              <p>{{ $t("utils.startingAmount") }}</p>
            </div>
          </div>
          <p class="m-flex p1 m-pd1-x">
            {{ $t("shouyi_yj")
            }}<span class="m-right">{{
              (sku.fixed_investment_amount * 1 + sku.fixed_investment_amount * (sku.rate / 100) * sku.day).toFixed(2)
            }}</span>
          </p>
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="show_tc" :confirmButtonText="$t('utils.confirm')"  @confirm="tcConfirm()">
      <div class="popup" v-html="tc_content"></div>
    </van-dialog>
   
    <div class="footers">
            <div class="titles">
                {{ $t('合作伙伴') }}
              </div>
            <div class="title2">
                {{ $t('电影项目合作机构') }}
            </div>
            <div class="list_box">
                <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.wbd.com%2Fnews%2Fwarner-bros-discovery-announces-cohort-2025-accelerator-program&t=Warner+Bros.+Discovery+Announces+Cohort+for+2025+Accelerator+Program">
                  <span class="iconfont icon-f" style="font-size: 34px;"></span>
                </a>
                <a target="_blank" href="https://x.com/intent/post?text=Warner%20Bros.%20Discovery%20Announces%20Cohort%20for%202025%20Accelerator%20Program&url=https%3A%2F%2Fwww.wbd.com%2Fnews%2Fwarner-bros-discovery-announces-cohort-2025-accelerator-program">
                  <span class="iconfont icon-x"></span>
                </a>
                <a target="_blank" href="https://www.instagram.com/">
                  <img style="width: 48px;" src="@/assets/images/ig.png" alt="">
                </a>
                <a target="_blank" href="https://www.youtube.com/wbd">
                  <span class="iconfont icon-a-rongqi259" style="font-size:56px;"></span>
                </a>
                <a target="_blank" href="https://www.tiktok.com/about?lang=en">
                  <img src="@/assets/images/dy.png" alt="">
                </a>
            </div>
            <div class="list2">
                <img src="@/assets/images/logo/6.png" alt="">
                <img src="@/assets/images/logo/4.png" alt="">
                <img src="@/assets/images/logo/2.png" alt="">
                <img src="@/assets/images/logo/5.png" alt="">
                <img src="@/assets/images/logo/3.png" alt="">
                <img src="@/assets/images/logo/1.png" alt="">
                <img src="@/assets/images/logo/8.png" alt="">
                <img src="@/assets/images/logo/7.png" alt="">
            </div>

           
           <footers></footers>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import {setLocalStorage, getLocalStorage, clearLocalStorage, removeLocalStorage } from '../../utils/toLang.js'
import Api from "../../interface/index";
import footers from '@/components/bsFooter.vue'

import { Swipe, SwipeItem, Icon, Progress, Dialog, Field, Tab, Tabs, Empty, NoticeBar } from "vant";
import videos from "@/components/videos.vue";
Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Tab).use(Tabs).use(Empty).use(NoticeBar);

export default {
  name: "Index",
  components: {
    videos,
    footers,
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
  },
  data() {
    return {
      videoSrc: "",
      lang: this.$i18n.locale || "zh_cn",
      show_kefu: false,
      msg_show: true,
      loading: false,
      icon: [],
      data: {
        banner:[]
      },
      show_img: false,
      show_tz: false,
      show_tc: false,
      tc_content: "",
      number: "",
      sku: [],
      tabs: [],
      xwtabs: [],
      xwList:[],
      active: 0,
      xwActive:0,
      wealth_data: [],
      listLength: 0,
      show_ts: false,
      wealth_number: "",
      wealth_sku: [],
      isSig: 1,
      logo:localStorage.getItem('logo') || '',
      stockList:[],
      notices:'',
      notice_num:0
    };
  },
  created() {
    this.$parent.footer("index");
    Fetch('/user/notice').then((r) => {
					this.notice_num = r.data.ok_read_num;
		});
    Fetch("/index/webconfig").then((r) => {
      this.notices = r.data.notice
    });
    Fetch("/index/itemClass").then((r) => {
      this.tabs = r.data
      this.wealthStart( this.tabs[0].id);
    });
    Fetch("/news/getCateList").then((r) => {
      this.xwtabs = r.data
      this.cateStart( this.xwtabs[0].id);
    });
    Fetch("/user/info").then((r) => {
      if (r.data.is_sign) {
        this.isSig = 2;
        return;
      }
      this.isSig = 1;
    });
  },
  mounted() {
    this.start();
    //代理标识设置
    if (this.$router.history.current.query.agent) {
      localStorage.setItem("agent", this.$router.history.current.query.agent);
    }
    console.log();
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
    // var type = 0;
    // if (this.$router.history.current.query.type) {
    //   this.active = parseInt(this.$router.history.current.query.type);
    //   type = this.$router.history.current.query.type;
    // }
  },
  methods: {
    formatNumbers(value) {
      value = value.split(',').join('')
      console.log(value,'value')
      if (value >= 100000000) {
        return (value / 100000000).toFixed(1).replace(/\.0$/, '') + this.$t('亿');
      } else if (value >= 10000) {
        return (value / 10000).toFixed(1).replace(/\.0$/, '') + this.$t('万');
      } else {
        return value.toString();
      }
    },
    investFun(type) {
      let arr = this.wealth_data.invest_term
      let item = arr.find(x => x.value == type)
      let a = item.name_text?item.name_text : ''
      return this.$t(a)
    },
    cateStart(type) {
      Fetch("/news/getCateNewsList", {
        cate_id: type,
        type:'index'
      }).then((r) => {
          if(r.code == 1) {
              this.xwList = r.data
          }else {
              this.$toast(r.info)
          }
      });
    },
    formatNumber(num) {
      // 检查是否为数字
      if (isNaN(num)) return num;
      
      // 将数字转换为字符串，保留两位小数
      let str = Number(num).toFixed(2);

      // 分割整数部分和小数部分
      let parts = str.split('.');
      let integerPart = parts[0];
      let decimalPart = parts[1];

      // 如果整数部分长度小于4，直接返回原数字
      if (integerPart.length < 4) {
        if (decimalPart === '00') {
          return integerPart;
        } else {
          return integerPart + '.' + decimalPart;
        }
      }

      // 反转整数部分，以便从右向左处理
      let reversed = integerPart.split('').reverse().join('');

      // 每三位添加一个逗号
      let formatted = '';
      for (let i = 0; i < reversed.length; i++) {
        if (i > 0 && i % 3 === 0) {
          formatted += ',';
        }
        formatted += reversed[i];
      }

      // 反转回来，并组合整数部分和小数部分
      formatted = formatted.split('').reverse().join('');

      // 如果小数部分是 '00'，则去掉小数部分
      if (decimalPart === '00') {
        return formatted;
      } else {
        return formatted + '.' + decimalPart;
      }
    },
    onVideoLoaded() {
      console.log("Video loaded");
    },
    onVideoEnded() {
      console.log("Video ended");
    },
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    tcConfirm(){
        setLocalStorage('popNotice', true, 172800)
        this.show_tc = false
    },
    hideDown() {
      this.show_img = false;
      this.$store.commit("setShowAdvert", false);
    },
    start() {
      Fetch("/index/int").then((r) => {
        //打包web请注释掉版本更新这段代码
        //-----------------------------------------
        // if(window.plus){
        // let appVersion1 = plus.runtime.version;
        // let appVersion2 = r.data.version.app_version;
        // //版本号不同则更新APP
        // if(parseInt(appVersion1.split(".").join(""))<parseInt(appVersion2.split(".").join(""))){
        // 	this.$dialog.alert({
        // 	  title: 'APP更新',
        // 	  message: r.data.version.app_instructions,
        // 	}).then(() => {
        // 		let u = navigator.userAgent;
        // 		let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
        // 		let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // 		if (isAndroid) {
        // 		 // alert("我是安卓");
        // 			window.location.href = r.data.version.android_app_down_url;
        // 		}
        // 		if (isIOS) {
        // 		 // alert("我是苹果");
        // 		 window.location.href = r.data.version.ios_app_down_url;
        // 		}
        // 	});
        // }
        // }
        //-----------------------------------------
        this.data = r.data;
        this.videoSrc = r.data.index_video_url;
        this.loading = true;
        // console.log(this.data, "this.data");
        const token = localStorage.getItem("token");
        let status = getLocalStorage('popNotice')
        if ( r.data.popup.show == 1 && !status ) {
          this.tc_content = r.data.popup.content;
          this.show_tc = true;
        }
      });
    },
    onChange(index) {
      let els = this.$refs.dian.querySelectorAll("div");
      for (let i = 0; i < els.length; i++) {
        els[i].className = "";
      }
      els[index].className = "selected";
    },
    buy(item) {
      if (this.isSig === 1) {
        this.$router.push("/contract");
        return;
      }
      this.sku = item;
      this.show_tz = true;
    },
    confirm() {
      // if (!this.number) {
      //   this.$toast(this.$t("item.inputAmount"));
      //   return false;
      // }
      Fetch("/index/item_apply", {
        id: this.sku.id,
        money: this.sku.fixed_investment_amount,
      }).then((r) => {
          if (r.code == 1) {
            this.$toast(r.info);
            setTimeout(() => {
              this.$router.push("/order");
            }, 500);
            return;
          }
          this.$toast(r.msg);
        })
        .catch((err) => {
          this.psd_val = "";
        });
    },
    wealthStart(type) {
      Fetch("/index/item_search", {
        name: "",
        // index_type: type,
        cate_id: type,
      }).then((r) => {
        this.wealth_data = r.data;
        this.listLength = r.data.list.length;
      });
    },
    sort(type) {
      this.wealthStart(this.tabs[type].id);
    },
    xwSort(type) {
      this.wealthStart(this.xwtabs[type].id);
    },
    cancelFun(){
      this.number = ''
    },
    wealthBuy(item) {
      if (this.isSig === 1) {
        this.$router.push("/contract");
        return;
      }
      this.wealth_sku = item;
      this.show_ts = true;
    },
    wealthConfirm() {
      if (!this.wealth_number) {
        this.$toast(this.$t("item.inputAmount"));
        return false;
      }
      Fetch("/index/item_apply", {
        id: this.wealth_sku.id,
        money: this.wealth_number,
      })
        .then((r) => {
          this.$toast(r.msg);
          if (r.code == 1) {
            this.$toast(r.info);
            setTimeout(() => {
              this.$router.push("/order");
            }, 500);
            return;
          }
        })
        .catch((err) => {
          // this.psd_val = '';
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-cell {
  padding: 15px 26px;
}
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
}
.red_top_bg {
  position: relative;
  position: fixed;
  top: 0;
  z-index: 10;
  background-color: #04006C;
  color: #101010;
  .logos {
    height: 34px;
    width: fit-content;
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
    // left: 20px;
    img {
      width: auto;
      height: 100%;
      display: block;
    }
  }
  .menu,.not_logo {
    height: 26px;
    width: 26px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .not_logo {
    width: 26px;
    height: 26px;
    position: relative;
    .num {
      position: absolute;
      right: 0px;
      top: 0px;
      transform: translate(50%,14%);
      background: red;
      color: #fff;
      padding: 2px 4px;
      font-size: 10px;
      border-radius: 10px;
    }
  }
}
.search_box {
  width: 80%;
  height: 29px;
  background-color: #f6f6f6;
  border-radius: 17px;
  margin: 8px 40px 0 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px 0 14px;

  .fdj {
    width: 16px;
    height: 16px;
    background: url(../images/item/fdj.png) no-repeat center center;
    background-size: 100% 100%;
  }

  .search_inp {
    flex: 1;
    margin: 0 8px;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    height: 20px;
  }

  .clear_inp {
    width: 20px;
    height: 20px;
    background: url(../images/item/clear.png) no-repeat center center;
    background-size: 100% 100%;
  }
}

.swiper-container {
  width: 100%;
  height: 260px;
  background: #ffffff;

  .van-swipe-item {
    overflow: hidden;
    img {
      min-width: 100%;
      height: 100%;
    }
  }

  a {
    float: left;
    width: 100%;
    height: 100%;
    position: relative;
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #00000030;
    }
  }
}
.work_box {
  background: #ffffff;
  padding: 17px 8px 4px 8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .item {
    width: 25%;
    text-align: center;
    margin-bottom: 10px;
    .item_img {
      width: 100%;
      border-radius: 5px;
      overflow: hidden;
      img {
        width: 44px;
        height: 44px;
      }
    }

    .item_title {
      width: 100%;
      line-height: 14px;
      font-size: 12px;
      color: #333333;
      text-align: center;
      transform: scale(0.85);
    }
  }
}

.work_box.query {
  .item {
    .item_img {
      border-radius: 5px;
      background: #f0f0f0;
    }

    .item_title {
      width: 100%;
      height: 14px;
      margin-left: 0;
      background: #f0f0f0;
    }
  }
}
.ads_box_1 {
  border-radius: 13px;
  margin-top: 10px;
  text-align: center;
  img {
    width: 95%;
  }
}
.ads_box {
  // background: rgba(255, 255, 255, 1);
  width: 97%;
  border-radius: 13px;
  margin: 10px auto 0 auto;
  display: flex;
  text-align: center;
  .ads_img {
  }
  img {
    width: 96%;
    border-radius: 5px;
  }
}
.items_1,
.items_2,
.items_3 {
  .items_tit {
    border-radius: 5px 5px 0 0;
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
    background: #ffffff;
    border-bottom: 1px solid #f7f7f7;
    padding: 0 14px;
    display: flex;
    justify-content: space-between;
    .tit_tip {
      display: contents;
      font-size: 12px;
      font-weight: normal;
      color: #b2b2b2;
      margin-left: 10px;
    }
    .tit_more {
      font-size: 12px;
      font-weight: normal;
      color: #b2b2b2;
    }
  }
  .item {
    background: #eee;
  }
}
.items_1 {
  .item {
    padding: 5px;
    box-shadow: 0px -10px 20px #00000010 inset;
    div {
      margin: 20px 0;
    }
    .item_tit {
      text-align: center;
      overflow: hidden;
      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: bold;
        font-size: 16px;
      }
    }
    .item_rate {
      text-align: center;
      color: #000000;
      font-size: 22px;
      font-weight: bold;
    }
    .item_desc {
      display: flex;
      p {
        width: 50%;
        text-align: center;
      }
    }
    .item_btn {
      text-align: center;

      button {
        width: 60%;
        min-width: 60px;
        background: #000000;
        color: #ffffff;
        padding: 10px 0px;
        border-radius: 10px;
      }
      .item_btn_over {
        background: #999;
      }
    }
  }
}
.items_2 {
  .item {
    display: flex;
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #ececec;
    div {
      margin: 15px 0;
    }
    .item_rate {
      width: 20%;
      p {
        padding: 5px 0;
      }
      p:nth-child(1) {
        font-weight: bold;
        font-size: 14px;
        color: #000;
      }
      p:nth-child(2) {
        color: #999;
      }
    }
    .item_tit {
      width: 55%;
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 5px 0;
      }
      p:nth-child(1) {
        font-weight: bold;
      }
      p:nth-child(2) {
        color: #999;
      }
    }
    .item_btn {
      width: 25%;
      button {
        min-width: 60px;
        margin-top: 12px;
        color: #000;
        padding: 5px 5px;
        border-radius: 5px;
        border: 1px solid #000;
      }
      .item_btn_over {
        color: #999;
        border: 1px solid #999;
      }
    }
  }
}
.items_3 {
  padding-top: 5px;
  background: #fff;
  .item {
    width: 94%;
    margin: 8px auto 20px auto;
    background: #F4F4F4;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 2px 4px #eee;

    .item_div1 {
      display: flex;
      justify-content:center;
      align-items: center;
      padding:15px 10px;
      font-size: 15px;
      p:nth-child(1) {
        // width: 90%;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p:nth-child(2) {
        color: #999;
      }
    }
    .item_img {
      width: 100%;
      height: fit-content;
      border-radius: 10px 10px 0px 0px;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 10px 10px 0px 0px;
        border: 1px solid #999;
      }
    }
    .item_text {
      font-size: 14px;
      color: #333;
      padding: 0 10px;
      word-break: break-all;
    }
    .item_div2 {
      width: 100%;
      margin: 0px auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      font-size: 14px;
      padding: 0 10px;
      .divs {
        width: 32%;
        height: 85px;
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0px 4px 8px #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px;
        flex-direction: column;
        p:nth-child(1) {
          color: #A399AE;
          margin:8px auto;
        }
      }
      div {
        width: fit-content;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .logos {
          width: 22px;
          height: 22px;
          margin-right: 2px;
        }
        p {
          padding: 0px;
          text-align: left;
          color: #A399AE;
          text-align: center;
          font-size: 13px;
          span {
            font-size: 16px;
            color: #000;
          }
        }
        .mt2 {
          margin-top: 5px;
        }
      }
      .bians {
        width: 1px;
        padding: 0px;
        height: 40px;
        background: #333;
      }
      .item_rate {
        p:nth-child(1) {
          font-weight: bold;
          color: #A399AE;
        }
      }
      .item_day {
        p:nth-child(1) {
          font-weight: bold;
          color: #A399AE;
        }
      }
      .item_min {
        p:nth-child(1) {
          font-weight: bold;
          color: #A399AE;
        }
      }
    }
    .item_div3 {
      color: #999;
      padding: 0px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 12px;
      span {
				font-size: 13px;
			}
      .item_btn {
        width:fit-content;
        display: flex;
				justify-content: flex-end;
				align-items: center;
        button {
          min-width: 60px;
          color: #000;
          padding: 5px 12px;
          border-radius: 5px;
          background: #EBF302;
          white-space: nowrap;
        }
        .item_btn_over {
          color: #999;
          border: 1px solid #999;
        }
      }
    }
    .item_div4 {
      width: 100%;
      padding: 0px 10px 20px 10px;
      margin-top: 10px;
      .flexs {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-bottom: 5px;
        color: #7F7E7E;
        font-size: 12px;
      }
      div:nth-child(1) {
        width: 100%;
      }
      
    }
  }
}
.popup {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  max-height: 60vh;
  padding: 26px 24px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 20px;
}
.h-title {
  font-size: 18px;
  padding: 18px 10px 6px 10px;
  font-weight: bold;
  font-size: 24px;
  font-weight: bold;
  color: transparent;
  background: linear-gradient(90deg, #0E726D, #FACB8F);
  -webkit-background-clip: text;
  background-clip: text;
  position: relative;
  display: inline-block;
}

.bg-video {
  width: 100%;
  height: 240px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.items {
  background: #038566;
  padding: 5%;
  .item_img {
    width: 100%;
    height: 198px;
    margin-bottom: 20px;
    img {
      width: 100%;
      display: block;
      height: 100%;
    }
  }
  .t1 {
    color: #29f5d5;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .newsroom__title {
    font-family: "Beatrice Bold",Arial,Helvetica,sans-serif;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: normal;         /* 依据语言规则在单词间换行 */
    white-space: normal;        /* 合并多余空格，在换行符和容器边缘处换行 */
    font-size: 22px;
    color: #fff;
    display: block;
    font-weight: bold;
    line-height: 30px;
    padding-bottom: 20px;
  }
}
.footers {
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 50px;
    .titles {
      color: #333;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
    }
    .title2 {
      color: #333;
      font-size: 15px;
      margin: 15px auto;
    }
    .list2 {
        display: flex;
        width:100%;
        margin: 0 auto 25px auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 15px;
        img {
          display: block;
          width: 22%;
          object-fit: contain;
          margin: 8px 0px;
        }
    }
    .list_box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0px 35px 0px;
      a {
        position: relative;
        display: block;
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        margin: 0px 20px;
        border-radius: 6px;
        .iconfont {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
        }
        span {
          font-size: 40px;
          color: #000;
        }
      }
    }
    .bottoms {
      width: 100%;
      height: fit-content;
      background: #04006C;
      padding:20px 20px 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .lists {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 25px 20px 45px 20px;
        a {
          display: flex;
          width: 32px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          margin: 0px 10px;
          border-radius: 6px;
          span {
            font-size: 20px;
            color: #fff;
          }
        }
      }
      .logo {
        width: 220px;
        height: fit-content;
        padding-bottom: 30px;
        img {
          display: block;
          width: 100%;
          height: auto;
        }
      }
    }
    .texts {
      width: 100%;
      height: fit-content;
      padding: 0 15px 30px 15px;
      background: #04006C;
      color: #fff;
      font-size: 13px;
      line-height: 18px;
    }
    .text {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 30px;
      background: #04006C;
      p {
        width: 100%;
        font-size: 10px;
        margin: 5px auto;
        text-align: center;
        color: #fff;
      }
    }
}
::v-deep .van-progress__pivot {
  display: none;
}
</style>
